export default "/images/delete.svg?e694d64b17a36423df8ed5052cf86e88";